import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TableAclState } from '../reducers/tableacl.reducer';

export const tableAclState: any = createFeatureSelector<TableAclState>('tableAclReducer');

export const tableAclRecords = createSelector(tableAclState, (state: any) => state?.tableAclRecords);

export const newlyCreatedAcl = createSelector(tableAclState, (state: any) => state?.createdAcl);

export const deletedAclRecord = createSelector(tableAclState, (state: any) => state?.deletedSid);

export const updatedRecordsAfterPaste = createSelector(tableAclState, (state: any) => state?.updatedRecords);

export const saveLoader = createSelector(tableAclState, (state: any) => {
  return state?.loader;
});

export const newlyCreatedaclDataBatch = createSelector(tableAclState, (state: any) => state?.newlyCreatedaclDataBatch);
